import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import {
  CHECKBOX,
  COMMENT,
  DATE,
  DROPDOWN,
  MATRIX_MULTIPLE_CHOICE,
  MATRIX_SINGLE_CHOICE,
  NUMBER,
  PREDEFINED_LIST,
  RADIO,
  STATIC_TABLE,
  TEXT,
  TOTAL
} from "../../../../ducks/collapsibleTableChart";

import React from "react";
import { ButtonToolbar, FormGroup, FormLabel, FormSelect } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import { FormattedMessage, useIntl } from "react-intl";
import { getSubQuestionModifiedId } from "../../../../utils/TableUtils";

const PivotTableModal = ({
  modalId,
  activeQuestion,
  questionGroups,
  modalSelectParameters,
  modalSelectQuestionList,
  showModal,
  onClose,
  onGroupSelect,
  onQuestionSelect,
  onFieldSelect,
  onStaticTableTypeSelect,
  onTableSelect,
  onMatrixSelect,
  onSubmit
}) => {
  const CSVArray = [TEXT, COMMENT, DATE, NUMBER, CHECKBOX, RADIO, DROPDOWN, PREDEFINED_LIST];
  const intl = useIntl();

  let modalParameters;
  if (modalSelectParameters[activeQuestion]) {
    modalParameters = modalSelectParameters[activeQuestion];
  }
  let modalQuestions;
  if (modalSelectQuestionList[activeQuestion]) {
    modalQuestions = modalSelectQuestionList[activeQuestion];
  }

  const isSimpleType = (type) => {
    let relevant = false;
    for (let i = 0; i < CSVArray.length; i++) {
      if (CSVArray[i] === type) {
        relevant = true;
        break;
      }
    }
    return relevant;
  };

  const groupDropdownSelection = (group) => {
    return (
      <option
        key={group.pageKey}
        value={group.pageKey}
        selected={modalParameters?.groupByQuestionGroupKey === group.pageKey ? "selected" : null}
      >
        {group.title}
      </option>
    );
  };

  const questionDropdownSelection = (table) => {
    const questionIdentifier = table.questionKey || table.questionId;
    return (
      <option
        value={questionIdentifier}
        key={questionIdentifier}
        selected={
          String(questionIdentifier) ===
          String(modalParameters?.groupByQuestion?.questionKey || modalParameters?.groupByQuestion?.questionId)
            ? "selected"
            : null
        }
      >
        {table.questionTitle}
      </option>
    );
  };

  const fieldDropdownSelection = () => {
    let options = [];
    const element = modalParameters.groupByQuestion;
    options.push(
      <option value={""} key={"field-blanc"}>
        {intl.formatMessage({ id: "collapsible.filter.pivot.modal.field" })}
      </option>
    );
    options.push(
      <option value={TOTAL} key={"field-total"}>
        {intl.formatMessage({ id: "collapsible.filter.pivot.modal.field.total" })}
      </option>
    );
    if (element.anwser?.anwserList) {
      element.anwser.anwserList.forEach((answer) => {
        let subquestionType = answer.questionType;
        if (excludeType(subquestionType, modalParameters)) {
          let colId;
          let rowId;
          let colKey;
          let rowKey;
          let identifier;
          if (answer && answer.tableIdentifier) {
            colId = answer.tableIdentifier.colId;
            rowId = answer.tableIdentifier.rowId;
            colKey = answer.tableIdentifier.columnKey;
            rowKey = answer.tableIdentifier.rowKey;
            identifier =
              colKey || rowKey
                ? colKey
                  ? colKey.toString()
                  : "" + rowKey
                  ? rowKey.toString()
                  : ""
                : (colId ? colId.toString() : "0") + (rowId ? rowId.toString() : "0");
          }

          let subquestionModifiedId = getSubQuestionModifiedId(element.questionId, identifier, rowId, colId);
          if (answer.title) {
            options.push(
              <option
                value={subquestionModifiedId}
                key={subquestionModifiedId}
                selected={modalParameters?.groupByFieldId === subquestionModifiedId ? "selected" : null}
              >
                {answer.title}
              </option>
            );
          }
        }
      });
    } else {
      let subquestionType = element.answer?.questionType;
      if (subquestionType !== TEXT && subquestionType !== COMMENT) {
        options.push(
          <option
            value={element.questionId}
            key={element.questionId}
            selected={modalParameters?.groupByFieldId === element.questionId ? "selected" : null}
          >
            {element.anwser?.title}
          </option>
        );
      }
    }
    return (
      <FormGroup  className="mb-3">
        <FormLabel>{intl.formatMessage({ id: "collapsible.filter.pivot.modal.field" })}</FormLabel>
        <FormSelect onChange={(e) => onFieldSelect(e, element)}>
          {options}
        </FormSelect>
      </FormGroup>
    );
  };

  const getStaticTableFields = (table) => {
    const rowCnt = table.anwser.anwserList.length;
    const colCnt = table.anwser.anwserList[0].anwserList.length;
    let newArray = [];
    let newTable = JSON.parse(JSON.stringify(table));

    if (modalParameters.pivotStaticTableChoice === "cols") {
      for (let cols = 0; cols < colCnt; cols++) {
        newArray[cols] = {
          compositeType: table.anwser.anwserList[0].anwserList[cols].compositeType,
          title:
            table.anwser.anwserList[0].anwserList[cols].title !== ""
              ? table.anwser.anwserList[0].anwserList[cols].title
              : intl.formatMessage({ id: "survey.editor.toolbox.staticTable.unnamed" })
        };
        newArray[cols].anwserList = [];
        for (let rows = 0; rows < rowCnt; rows++) {
          newArray[cols].anwserList[rows] = table.anwser.anwserList[rows].anwserList[cols];
        }
      }
      newTable.anwser.anwserList = newArray;
    } else {
      return table;
    }

    return newTable;
  };

  const staticTableDropdownSelection = () => {
    const element = getStaticTableFields(modalParameters.groupByQuestion);
    let options = [];
    options.push(
      <option value="static-blanc" key="static-blanc">
        {intl.formatMessage({ id: "collapsible.filter.pivot.modal.field" })}
      </option>
    );
    element.anwser?.anwserList.forEach((column, index) => {
      let subquestionType = column.questionType;
      if (subquestionType !== TEXT && subquestionType !== COMMENT) {
        let colKey;
        let rowKey;
        if (column && column.anwserList[0].tableIdentifier) {
          colKey = column.anwserList[0].tableIdentifier.columnKey;
          rowKey = column.anwserList[0].tableIdentifier.rowKey;
        }

        const colName =
          column.title !== "" ? column.title : intl.formatMessage({ id: "survey.editor.toolbox.staticTable.unnamed" });
        const indetifier = {
          groupByColKey: colKey,
          groupByRowKey: rowKey,
          name: colName
        };

        options.push(
          <option
            value={JSON.stringify(indetifier)}
            key={`column-${index}`}
            selected={
              modalParameters?.groupByColumnKey === colKey && modalParameters?.groupByRowKey === rowKey
                ? "selected"
                : null
            }
          >
            {colName}
          </option>
        );
      }
    });
    return (
      <FormGroup  className="mb-3">
        <FormLabel>{intl.formatMessage({ id: "collapsible.filter.pivot.modal.field" })}</FormLabel>
        <FormSelect onChange={onTableSelect}>
          {options}
        </FormSelect>
      </FormGroup>
    );
  };

  const staticTableTypeSelection = () => {
    return (
      <ButtonToolbar>
        <ButtonGroup aria-label="static table Auswahl">
          <Button
            active={modalParameters.pivotStaticTableChoice && modalParameters.pivotStaticTableChoice === "cols"}
            variant="secondary"
            onClick={() => onStaticTableTypeSelect("cols")}
          >
            {intl.formatMessage({ id: "survey.editor.matrix.column.choices" })}
          </Button>
          <Button
            active={modalParameters.pivotStaticTableChoice && modalParameters.pivotStaticTableChoice === "rows"}
            variant="secondary"
            onClick={() => onStaticTableTypeSelect("rows")}
          >
            {intl.formatMessage({ id: "survey.editor.matrix.row.choices" })}
          </Button>
        </ButtonGroup>
      </ButtonToolbar>
    );
  };

  const matrixDropdownSelection = () => {
    let res = [];
    res.push(
      <option value={""} key="matrix-blanc">
        {intl.formatMessage({ id: "collapsible.filter.pivot.modal.field" })}
      </option>
    );
    const question = modalParameters?.groupByQuestion;
    if (question?.anwser?.anwserList) {
      question.anwser.anwserList.forEach((answer) => {
        if (answer.title) {
          res.push(
            <option
              value={JSON.stringify({
                name: answer.title,
                id: answer.tableIdentifier.rowKey
              })}
              key={answer.tableIdentifier.rowKey}
              selected={modalParameters?.groupByRowKey === answer.tableIdentifier.rowKey ? "selected" : null}
            >
              {answer.title}
            </option>
          );
        }
      });
    }

    return res;
  };

  const thirdLayerSelection = () => {
    if (!isSimpleType(modalParameters.groupByQuestion.questionType)) {
      if (
        modalParameters.groupByQuestion.questionType === MATRIX_SINGLE_CHOICE ||
        modalParameters.groupByQuestion.questionType === MATRIX_MULTIPLE_CHOICE
      ) {
        return (
          <FormGroup  className="mb-3">
            <FormLabel>
              <FormattedMessage id="collapsible.filter.pivot.modal.field" />
            </FormLabel>
            <FormSelect onChange={onMatrixSelect}>
              {matrixDropdownSelection()}
            </FormSelect>
          </FormGroup>
        );
      } else if (modalParameters.groupByQuestion.questionType === STATIC_TABLE) {
        return (
          <>
            {staticTableTypeSelection()}
            {modalParameters.pivotStaticTableChoice && staticTableDropdownSelection()}
          </>
        );
      } else {
        return fieldDropdownSelection();
      }
    }
  };

  return (
    <Modal show={showModal} onHide={onClose} id={modalId}>
      <Modal.Header closeButton>
        <Modal.Title>{intl.formatMessage({ id: "collapsible.filter.pivot.modal.title" })}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormGroup  className="mb-3">
          <FormLabel>
            <FormattedMessage id="collapsible.filter.pivot.modal.section" />
          </FormLabel>
          <FormSelect onChange={onGroupSelect}>
            <option value={""} key="section-blanc">
              {intl.formatMessage({ id: "collapsible.filter.pivot.modal.section" })}
            </option>
            {questionGroups && questionGroups.map(groupDropdownSelection)}
          </FormSelect>
        </FormGroup>
        {modalQuestions && modalQuestions.length > 0 && (
          <FormGroup id="pivotQuestion">
            <FormLabel>
              <FormattedMessage id="collapsible.filter.pivot.modal.question" />
            </FormLabel>
            <FormSelect onChange={onQuestionSelect}>
              <option value={""} key="section-blanc">
                {intl.formatMessage({ id: "collapsible.filter.pivot.modal.question" })}
              </option>
              {modalQuestions && modalQuestions.map(questionDropdownSelection)}
            </FormSelect>
          </FormGroup>
        )}
        {modalParameters?.groupByQuestion && thirdLayerSelection()}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {intl.formatMessage({ id: "app.common.action.cancel" })}
        </Button>
        <Button
          variant="primary"
          disabled={
            !Object.values(modalSelectParameters).some((e) => !!e?.groupByQuestionGroupKey) ||
            !Object.values(modalSelectParameters).some((e) => !!e?.groupByQuestion?.questionId)
          }
          onClick={(e) => onSubmit(e, null, null, true)}
        >
          {intl.formatMessage({ id: "app.common.action.take.over" })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

function excludeType(subquestionType, modalParameters) {
  let result = true;
  switch (subquestionType) {
    case TEXT:
      result = false;
      break;
    case COMMENT:
      result = false;
      break;
    case NUMBER:
      result = NUMBER !== modalParameters.baseQuestionType && NUMBER !== modalParameters.baseColumnType;
      break;
    default:
      break;
  }
  return result;
}

PivotTableModal.propTypes = {
  modalId: PropTypes.string,
  activeQuestion: PropTypes.string,
  questionGroups: PropTypes.array,
  modalSelectQuestionList: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  modalSelectParameters: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  showModal: PropTypes.bool,
  onClose: PropTypes.func,
  onGroupSelect: PropTypes.func,
  onQuestionSelect: PropTypes.func,
  onFieldSelect: PropTypes.func,
  onStaticTableTypeSelect: PropTypes.func,
  onTableSelect: PropTypes.func,
  onMatrixSelect: PropTypes.func,
  onSubmit: PropTypes.func,
  intl: PropTypes.object
};

export default PivotTableModal;
